module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_8.5e8e0520.png";